import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as projectApi from '../../lib/api/project';
import { recentOneYearStr, recentOneYearEndStr } from '../../utils/calcDatetime';
import { readStoredContractType } from '../../utils/contractType';

// "계약 관리" 메뉴(프로젝트 관리 + 유지보수 관리 통합, 2026-10-19). 기존 projects.js/mprojects.js는
// 다른 화면(검색 자동완성, 대시보드 위젯, 유지보수 상세)에서 계속 쓰고 있어 그대로 두고,
// 이 목록 화면만을 위한 새 모듈로 분리했다.
const [LIST_CONTRACTS, LIST_CONTRACTS_SUCCESS, LIST_CONTRACTS_FAILURE] =
  createRequestActionTypes('project/LIST_CONTRACTS');

export const listContracts = createAction(
  LIST_CONTRACTS,
  (searchData) => searchData,
);
const listContractsSaga = createRequestSaga(
  LIST_CONTRACTS,
  projectApi.getContracts,
);

const UNLOAD_CONTRACTS = 'project/UNLOAD_CONTRACTS';
export const unloadContracts = createAction(UNLOAD_CONTRACTS);

const SET_CONTRACT_FILTERS = 'project/SET_CONTRACT_FILTERS';
export const setContractFilters = createAction(
  SET_CONTRACT_FILTERS,
  (filters) => filters,
);

const RESET_CONTRACT_FILTERS = 'project/RESET_CONTRACT_FILTERS';
export const resetContractFilters = createAction(RESET_CONTRACT_FILTERS);

export function* contractsSaga() {
  yield takeLatest(LIST_CONTRACTS, listContractsSaga);
}

const initialState = {
  totals: null,
  contracts: null,
  error: null,
  defaultFilters: {
    searchGrade: '',
    // 유형 칩(전체/프로젝트/유지보수) - 마지막 선택을 localStorage에서 기억해온다.
    searchPrjTyp: readStoredContractType(
      typeof window !== 'undefined' ? window.localStorage : null,
    ),
    searchPrjImpt: '',
    searchKeyword: 'cstNm',
    searchWords: '',
    searchDpt: '',
    searchUsr: '',
    searchStrtDt: recentOneYearStr,
    searchEndDt: recentOneYearEndStr,
  },
};

const contracts = handleActions(
  {
    [LIST_CONTRACTS_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      totals: data?.totals,
      contracts: (data?.list || []).map((project) => ({
        id: project.prjUuid,
        prjUuid: project.prjUuid,
        prjSeq: project.prjSeq,
        prjNo: project.prjNo,
        prjTyp: project.prjTyp,
        expDay: project.expDay,
        cstStatus: project.cstStatus,
        bookingDay: project.bookingDay,
        cstGrade: project.cstGrade,
        cmpGrade: project.cmpGrade, //1/2/3/4
        cmpStatus: project.cmpStatus, //착수보고/분석설계/구축(이행)/완료(검수)
        cstNm: project.cstNm, //사업명
        totalPurchase: project?.totalPurchase,
        totalSales: project?.totalSales,
        totalProfit: project?.totalProfit,
        vendorCmpNm: project.vendorCmpNm,
        useYn: project.useYn,
        ordYn: project.ordYn,
        crtDptNm: project.crtDptNm,
        crtNm: project.crtNm,
        crtGradeNm: project.crtGradeNm,
        crtDt: project.crtDt,
        cngNm: project.cngNm,
        cngDt: project.cngDt,
      })),
      error: null,
    }),
    [LIST_CONTRACTS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_CONTRACTS]: () => initialState,
    [RESET_CONTRACT_FILTERS]: (state) => ({
      ...state,
      defaultFilters: initialState.defaultFilters,
    }),
    [SET_CONTRACT_FILTERS]: (state, { payload: filters }) => ({
      ...state,
      defaultFilters: filters,
    }),
  },
  initialState,
);

export default contracts;
